<template>
  <b-modal
    v-model="trigger"
    :centered="true"
    :no-close-on-backdrop="dontCloseWhenClickedOutside"
    :no-close-on-esc="dontCloseWhenEscapePressed"
    :hide-header-close="dontShowCloseIcon"
    :hide-footer="true"
    :hide-header="true"
    @cancel="eventCancel($event)"
    :size="'lg'"
  >
    <div class="empanel-modal-close">
      <span v-if="!isEdit" class="Modal-head-text">Add Finance Details</span>
      <span v-if="isEdit" class="Modal-head-text">Edit Finance Details</span>
      <p class>
        <img
          @click="closeContactModal()"
          class="cursor-pointer modal-close-button mt-n1"
          style="float:right"
          src="@/assets/images/close1.svg"
        />
      </p>
    </div>
    <div class="col-12 mt-2">
      <b-form-group class="source-sans-pro text-left ml-3 mr-3" label="Financial Year">
        <w-dropdown
          class="width-control-small"
          :options="financialYearDropdown"
          @dropdownChange="getFinancialYear($event)"
          :selected="financialForm.financeYear"
          :disabled="isEdit"
        />
      </b-form-group>
    </div>
    <div class="row">
      <div class="col-6 p-0">
        <w-text-input
          class="text-left ml-5"
          style="width:72% !important"
          :inputAdditions="'mobile'"
          :labelName="$t(`Assessed turnover over (lakhs)`)"
          :validation="'required|regex_negnumber'"
          @textInputChange="getTurnover($event)"
          :isdCode="'₹'"
          :defaultValue="financialForm.turnover"
          :type="'number'"
          :maxDigits="'10'"
          :allownegative="false"
        />
      </div>
      <div class="col-6 p-0">
        <w-text-input
          class="text-left ml-5"
          style="width:72% !important"
          :inputAdditions="'mobile'"
          :labelName="$t(`Asset value (lakhs)`)"
          @textInputChange="getAssetValue($event)"
          :validation="'required|regex_number_decimal'"
          :defaultValue="financialForm.assetValue"
          :type="'number'"
          :maxDigits="'10'"
          :allownegative="true"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-6 mt-0 p-0">
        <w-text-input
          style="width:72% !important"
          class="text-left ml-5"
          :inputAdditions="'mobile'"
          :labelName="$t(`Gross Profit (lakhs)`)"
          :validation="'required|regex_negnumber'"
          @textInputChange="getGrossProfit($event)"
          :isdCode="'₹'"
          :defaultValue="financialForm.grossProfit"
          :type="'number'"
          :maxDigits="'10'"
          :allownegative="false"
        />
      </div>
      <div class="col-6 mt-0 p-0">
        <w-text-input
          class="text-left ml-5"
          style="width:72% !important"
          :inputAdditions="'mobile'"
          :labelName="$t(`Net Profit (lakhs)`)"
          :validation="'required|regex_number'"
          @textInputChange="getNetProfit($event)"
          :isdCode="'₹'"
          :defaultValue="financialForm.netProfit"
          :type="'number'"
          :maxDigits="'10'"
          :allownegative="true"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-6 mt-0 p-0">
        <w-text-input
          class="text-left ml-5"
          style="width:72% !important"
          :inputAdditions="'mobile'"
          :labelName="$t(`RoA`)"
          @textInputChange="getRoaValue($event)"
          :validation="'required|regex_number_decimal'"
          :type="'number'"
          :defaultValue="financialForm.roa"
          :maxDigits="'10'"
          :allownegative="true"
        />
      </div>
      <div class="col-6 mt-0 p-0">
        <w-text-input
          class="text-left ml-5"
          style="width:72% !important"
          :inputAdditions="'mobile'"
          :labelName="$t(`RoCE`)"
          @textInputChange="getRoceValue($event)"
          :validation="'required|regex_number_decimal'"
          :type="'number'"
          :defaultValue="financialForm.roce"
          :maxDigits="'10'"
          :allownegative="true"
        />
      </div>
    </div>
    <div class="col-8 mt-2">
      <FileUploader
        class="text-left ml-4"
        :id="'financialAttachment'"
        :heading="'Attach Relevant documents/proofs *'"
        @fileInputChange="getFinancialAttachment($event)"
      />
      <div class="col-10 ml-4 mt-1 p-0 pt-1" v-if="financialForm.financialAttachment">
        <ul style="list-style-type:disc;">
          <li>
            <a
              @click="showAttachFile(financialForm.financialAttachment)"
              href="#"
            >{{getFileName(financialForm.financialAttachment)}}</a>
          </li>
        </ul>
      </div>
    </div>
    <div class="row mt-3 mr-1">
      <div class="col">
        <b-button
          v-if="!isEdit"
          class="ml-2 button-class"
          :disabled="checkAllFilledFields()"
          @click="saveFinanceDetails()"
        >Save</b-button>
        <b-button
          v-if="isEdit"
          class="ml-2 button-class"
          :disabled="checkAllFilledFields()"
          @click="saveFinanceDetails()"
        >Update</b-button>
      </div>
    </div>
    <w-loadingSpinner :loadSpinner="loading" />
  </b-modal>
</template>
<script>
import DropDown from "../widgets/DropDown";
import TextInput from "../widgets/TextInput";
import FileUploader from "../widgets/FileUploader";
import loadingSpinner from "../widgets/LoadingSpinner";
import { PartnerService } from "../services/partnerService";
import { OnBoardingServices } from "../services/onBoardingService";
const OnBoardingService = new OnBoardingServices();
const partnerService = new PartnerService();
export default {
  components: {
    "w-text-input": TextInput,
    "w-dropdown": DropDown,
    FileUploader,
    "w-loadingSpinner": loadingSpinner
  },
  props: [
    "trigger",
    "dontCloseWhenClickedOutside",
    "dontShowCloseIcon",
    "dontCloseWhenEscapePressed",
    "isEdit",
    "editFinanceDetail",
    "categoryCode"
  ],
  created() {
    this.getPartnerInfo();
    this.getEditFinanceDetails();
  },
  data() {
    return {
      financialForm: {
        companyCode: "",
        categoryCode: "",
        financeYear: "",
        turnover: "",
        grossProfit: "",
        netProfit: "",
        assetValue: "",
        roa: "",
        roce: "",
        financialAttachment: "",
        financialSiteUrl: ""
      },
      loading: false,
      financialYearDropdown: [],
      financialYear: "",
      companycode: ""
    };
  },
  methods: {
    getEditFinanceDetails() {
      if (this.isEdit) {
        this.financialForm.financeYear = this.editFinanceDetail.financeYear;
        let dropdownValue = {
          value: "",
          text: ""
        };
        dropdownValue.value = this.editFinanceDetail.financeYear;
        let year1 = this.editFinanceDetail.financeYear;
        let year2 = year1 + 1;
        dropdownValue.text = year1 + "-" + year2;
        this.financialYearDropdown.push(dropdownValue);
        this.financialForm.turnover = this.editFinanceDetail.turnover;
        this.financialForm.grossProfit = this.editFinanceDetail.grossProfit;
        this.financialForm.netProfit = this.editFinanceDetail.netProfit;
        this.financialForm.assetValue = this.editFinanceDetail.assetValue;
        this.financialForm.documentNumber = this.editFinanceDetail.documentNo;
        this.financialForm.roa = this.editFinanceDetail.roa;
        this.financialForm.roce = this.editFinanceDetail.roa;
        this.financialForm.financialAttachment = this.editFinanceDetail.financialAttachment;
        console.log("Child Edit Created", this.editFinanceDetail);
      }
    },
    checkAllFilledFields() {
      if (
        this.financialForm.financeYear &&
        this.financialForm.turnover &&
        this.financialForm.grossProfit &&
        this.financialForm.netProfit &&
        this.financialForm.assetValue &&
        this.financialForm.roa &&
        this.financialForm.roce &&
        this.financialForm.financialAttachment &&
        this.errors.items.length == 0
      ) {
        return false;
      }
      return true;
    },
    getPartnerInfo() {
      partnerService.getPartnerInfo().then(resp => {
        this.companycode = resp.response.currentCompanyCode;
        this.$root.isInternational =
              resp.response.countryDetail.countryCode == 100 ? false : true;
        this.getFinancialYearDropdown();
      });
    },
    getFinancialYearDropdown() {
      partnerService
        .getFinancialYearDropdown(this.categoryCode, this.companycode)
        .then(res => {
          this.financialYearDropdown.push({
            value: 0,
            text: "Select one",
            disabled: true
          });
          res.response.forEach(element => {
            let dropdownValue = {
              value: "",
              text: ""
            };
            let year = element.split("-");
            dropdownValue.value = year[0];
            dropdownValue.text = element;
            // console.log("dropdownValue", dropdownValue);
            this.financialYearDropdown.push(dropdownValue);
          });
        });
    },
    getFinancialYear(event) {
      this.financialForm.financeYear = event;
    },
    getTurnover(event) {
      this.financialForm.turnover = event;
    },
    getGrossProfit(event) {
      this.financialForm.grossProfit = event;
    },
    getNetProfit(event) {
      this.financialForm.netProfit = event;
    },
    getAssetValue(event) {
      this.financialForm.assetValue = event;
    },
    getRoaValue(event) {
      this.financialForm.roa = event;
    },
    getRoceValue(event) {
      this.financialForm.roce = event;
    },
    getFinancialAttachment(event) {
      this.loading = true;
      console.log(event[0]);
      let data = new FormData();
      let file = event[0];
      console.log(file);
      // data.append("name", "my-file");
      data.append("file", file);
      OnBoardingService.uploadAttachments(data).then(resp => {
        this.loading = false;
        if (resp) {
          this.financialForm.financialAttachment = resp.UniqueID;
          this.financialForm.financialSiteUrl = resp.SiteUrl;
        }
      });
    },
    showAttachFile(event) {
      this.loading = true;
      OnBoardingService.downLoadDocument(event)
        .then(res => {
          this.loading = false;
        })
        .catch(e => {
                window.alert("Something went wrong! try again later");
          this.loading = false;
        });
    },
    getFileName(fileName) {
      var fileNameFinal = "";
      fileNameFinal = fileName.split(/_(.+)/)[1];
      return fileNameFinal;
    },
    saveFinanceDetails() {
      this.loading = true;
      this.financialForm.companyCode = this.companycode;
      this.financialForm.categoryCode = this.categoryCode;
      partnerService
        .saveFinanceDetail(this.financialForm)
        .then(res => {
            if (res.failureMessage) {
              this.$emit("alertOnSave", res.failureMessage); 
                window.alert(res.failureMessage);
              this.loading = false;
            } else {
          this.loading = false;
          this.$emit("afterSave");
            }
        })
        .catch(e => {
                window.alert("Something went wrong! try again later");
          this.loading = false;
        });
    },
    closeContactModal(event) {
      this.$emit("eventClose", event);
    }
  }
};
</script>
<style scoped>
.button-class {
  width: 100px;
  height: 30px;
  font-family: "Source Sans Pro", sans-serif;
  font-size: 14px;
  color: white !important;
  border-radius: 2px;
  background-color: #1579ab;
  margin-bottom: 30px;
  display: block;
  margin-left: auto !important;
  margin-right: auto !important;
}
.button-class:disabled {
  color: white !important;
}
</style>